import { useState, useEffect } from 'react';
import { areNotificationsEnabled } from '@/services/notifications/oneSignalService';
import { useAuth } from '@/contexts/auth';

export const useNotificationPrompt = () => {
  const { user } = useAuth();
  const [shouldShowPrompt, setShouldShowPrompt] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Only show for authenticated users
    if (!user) {
      setShouldShowPrompt(false);
      return;
    }

    // Check if notifications are already enabled
    const notificationsEnabled = areNotificationsEnabled();
    
    // Check if user has previously dismissed the prompt
    const hasBeenDismissed = localStorage.getItem('notification-prompt-dismissed') === 'true';
    
    // Only show prompt if notifications are not enabled and hasn't been dismissed
    if (!notificationsEnabled && !hasBeenDismissed) {
      setShouldShowPrompt(true);
    } else {
      setShouldShowPrompt(false);
    }
  }, [user]);

  const dismissPrompt = () => {
    setShouldShowPrompt(false);
    setIsDismissed(true);
    localStorage.setItem('notification-prompt-dismissed', 'true');
  };

  const resetPrompt = () => {
    localStorage.removeItem('notification-prompt-dismissed');
    setShouldShowPrompt(true);
    setIsDismissed(false);
  };

  return {
    shouldShowPrompt,
    isDismissed,
    dismissPrompt,
    resetPrompt
  };
};